module.exports = __webpack_public_path__ + "img/logo-sem.98f40896.png";